import React from "react";
import { useRacketLabAdminT } from "../../i18n/racketLabAdminI18n";

/**
 * FlagBadge — colour-coded chip for feature flags / hard-blocks.
 *
 * Three tones:
 *   - "hard"  → red (HARD-blocked surfaces · MUST stay off)
 *   - "safe"  → green (safe-by-default · enabled OK)
 *   - "mock"  → amber (mock / preview · not real)
 *   - "info"  → slate (informational baseline)
 *
 * QUICK 1.B.bis i18n migration: added optional `labelKey` and `valueKey`
 * props. When provided, they are resolved through the racketLab admin
 * dictionary; otherwise the legacy `label`/`value` literals are rendered
 * unchanged (backward compatible with un-migrated callers).
 */
const STYLES = {
  hard: "bg-rose-100 text-rose-800 border-rose-200",
  safe: "bg-emerald-100 text-emerald-800 border-emerald-200",
  mock: "bg-amber-100 text-amber-800 border-amber-200",
  info: "bg-slate-100 text-slate-700 border-slate-200",
};

export const FlagBadge = ({ tone = "info", label, value, labelKey, valueKey, dataTestId }) => {
  const t = useRacketLabAdminT();
  const cls = STYLES[tone] || STYLES.info;
  const resolvedLabel = labelKey ? t(labelKey) : label;
  const resolvedValue = valueKey ? t(valueKey) : String(value);
  return (
    <span
      data-testid={dataTestId || `rl-flag-badge-${tone}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-medium ${cls}`}
    >
      <span className="opacity-70">{resolvedLabel}</span>
      <span className="font-semibold">{resolvedValue}</span>
    </span>
  );
};

export default FlagBadge;
